import { ContractIQMenu } from "../components/organisms/ContractIQMenu";

export const ContractIQPage = () => <ContractIQMenu />;
